/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_TokenInputs */

const fr_label_token = /** @type {(inputs: Label_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token Directus`)
};

const en_label_token = /** @type {(inputs: Label_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directus Token`)
};

/**
* | output |
* | --- |
* | "Directus Token" |
*
* @param {Label_TokenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_token = /** @type {((inputs?: Label_TokenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_TokenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_token(inputs)
	return en_label_token(inputs)
});